import React, { useState, useEffect } from "react";
import { ArrowDownCircle, ArrowUpCircle, ShoppingCart, DollarSign, Send, Download, TrendingUp, Gift, Users, List } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import BottomNav from "../components/BottomNav";

const HistoryPage = () => {
  const { user, authAxios } = useAuth();
  const { t } = useLanguage();
  const [transactions, setTransactions] = useState([]);

  useEffect(() => { fetchHistory(); }, []);

  const fetchHistory = async () => {
    try {
      const api = authAxios();
      const res = await api.get(`/history/${user.id}`);
      setTransactions(res.data);
    } catch (e) { console.error(e); }
  };

  const getIcon = (type) => {
    const icons = {
      DEPOSIT: <ArrowDownCircle size={20} className="text-green-500" />,
      WITHDRAWAL: <ArrowUpCircle size={20} className="text-red-500" />,
      BUY: <ShoppingCart size={20} className="text-blue-500" />,
      SELL: <DollarSign size={20} className="text-purple-500" />,
      SEND: <Send size={20} className="text-cyan-500" />,
      SEND_USDT: <Send size={20} className="text-red-500" />,
      RECEIVE: <Download size={20} className="text-green-500" />,
      RECEIVE_USDT: <Download size={20} className="text-green-500" />,
      STAKE: <TrendingUp size={20} className="text-yellow-500" />,
      SPIN: <Gift size={20} className="text-pink-500" />,
      BONUS: <Gift size={20} className="text-primary" />,
      REFERRAL: <Users size={20} className="text-primary" />
    };
    return icons[type] || <List size={20} />;
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: <span className="badge-pending">{t("pending")}</span>,
      completed: <span className="badge-live">{t("completed")}</span>,
      rejected: <span className="badge-blocked">{t("rejected")}</span>
    };
    return badges[status];
  };

  return (
    <div className="min-h-screen pb-24 p-4" data-testid="history-page">
      <h1 className="font-manrope font-bold text-2xl mb-6">{t("history")}</h1>

      <div className="space-y-2">
        {transactions.map((tx) => (
          <div key={tx.id} className="transaction-item">
            <div className="flex items-center gap-3">
              {getIcon(tx.type)}
              <div>
                <p className="font-semibold">{tx.type}</p>
                <p className="text-muted-foreground text-xs truncate max-w-[180px]">{tx.description}</p>
                <p className="text-muted-foreground text-xs">{new Date(tx.created_at).toLocaleString()}</p>
              </div>
            </div>
            <div className="text-right">
              <p className={`font-manrope font-bold ${["DEPOSIT", "RECEIVE", "RECEIVE_USDT", "BONUS", "REFERRAL", "REFERRAL_BONUS", "SPIN"].includes(tx.type) ? "text-green-500" : "text-red-500"}`}>
                {["DEPOSIT", "RECEIVE", "RECEIVE_USDT", "BONUS", "REFERRAL", "REFERRAL_BONUS", "SPIN"].includes(tx.type) ? "+" : "-"}{tx.currency === "BNB" ? tx.amount : tx.amount.toFixed(tx.currency === "USDT" ? 2 : 0)} {tx.currency}
              </p>
              {getStatusBadge(tx.status)}
            </div>
          </div>
        ))}
        {transactions.length === 0 && <p className="text-center text-muted-foreground py-8">{t("noTransactions")}</p>}
      </div>

      <BottomNav />
    </div>
  );
};

export default HistoryPage;
